function slideAcross(elements) {
	if (!Array.isArray(elements)) throw new Error(`Expected array, recieved ${typeof elements}`)
	if (elements.some(e => !(e instanceof HTMLElement)))
		throw new Error('Elements must be of type HTMLElement')

	const toLeft = elements.filter(el => el.dataset.slide === 'left')
	const toRight = elements.filter(el => el.dataset.slide === 'right')

	if (!window) {
		throw new Error('window not defined')
	} else {
		window.addEventListener('scroll', () => {
			;[...toLeft, ...toRight].forEach(el => {
				const isVisisble = el.getBoundingClientRect().top <= window.innerHeight
				const { slide } = el.dataset
				const amount = window.innerHeight - el.getBoundingClientRect().top
				const value = slide === 'left' ? `-${amount}px` : `${amount}px`
				const translateDirection = `translateX(${value})`

				isVisisble && window.innerWidth > 780 && (el.style.transform = translateDirection)

				// isVisisble && console.log(amount)
			})
		})
	}
}

export default slideAcross
